import React, { useEffect, useMemo, useState } from "react";
import {
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  TableContainer,
  Paper,
  Typography,
  IconButton,
  Button,
  Chip,
  TablePagination,
  styled,
  tableCellClasses,
  Box,
  TextField,
  Backdrop,
  CircularProgress,
  Skeleton,
  Grid,
  Avatar,
  Divider,
  Card,
  FormControl,
} from "@mui/material";
import {
  Edit,
  Delete,
  Visibility,
  FilterList,
  Add,
  Search,
  RestartAlt,
} from "@mui/icons-material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import { axiosAPI } from "../../Components/AxiosComponents/Axios";
import { decryptId, encryptId } from "../../Components/CryptoComponent";
import SelectInput from "../../Components/InputComponents/SelectInput";
import {
  errorNotify,
  successNotify,
} from "../../Components/ToastComponent/ToastNotification";
import CommonButton from "../../Components/InputComponents/CommonButton";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: `#2C5F8E`,
    color: `#FFFFFF`,
    fontSize: 14,
    fontWeight: 500,
    whiteSpace: "nowrap",
    fontFamily: "Geist, sans-serif",
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
    fontFamily: "Geist, sans-serif",
  },
}));

const StyledTableRow = styled(TableRow)(() => ({
  "&:nth-of-type(even)": {
    backgroundColor: `#EBF2FF`,
  },
  "&:last-child td, &:last-child th": {
    border: 0,
  },
  "&:hover": {
    backgroundColor: "#D6E6F2",
    boxShadow: "0px 0px 5px 0px grey",
  },
}));

const ClientJobApplicantList = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const { id, title } = useParams();
  const [decryptedId, setdecryptedId] = useState(
    decryptId(decodeURIComponent(id))
  );

  const decryptedTitle = decryptId(decodeURIComponent(title));

  const [applicantData, setApplicantData] = useState([]);

  const [jobData, setJobData] = useState({});
  
  

  const [totalJoined, setTotalJoined] = useState();
  const [totalInterviewAttended, setTotalInterviewAttended] = useState();
  const [totalInterviewSelected, setTotalInterviewSelected] = useState();

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(25);
  const [loaderOpen, setLoaderOpen] = useState(true);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleApplyFilters = () => {
    getData();
  };

  const [filterData, setFilterData] = useState({
    CI_Name: "",
    CI_PassportNo: "",
    CI_PrimaryMobile: "",
    CI_PrimaryEmail: "",
  });

  const paginationState = {
    pagination: { page, rowsPerPage },
    filterData: filterData,
  };

  const [statusList, setStatusList] = useState([]);

  const getStatus = async () => {
    try {
      const res = await axiosAPI.get(`/JobApplicationStatus/list`);
      setStatusList(res?.data?.data || []);
    } catch (err) {
      console.error(err);
    }
  };

  const [candidateID, setCandidateID] = useState("");
  const [JobApplicationId,setJobApplicationId] = useState('')

  const handleStatusChange = (e) => {
        
    axiosAPI
      ?.post(`/Candidate/updateInterviewStatus/${JobApplicationId}`, {
        JA_CandidateId: candidateID,
        JA_JobId: jobData?.JD_Id,
        JA_StatusId: e?.target.value,
      })
      .then((res) => {
        if (res?.data?.success) {
          successNotify(res?.data?.data?.message);
          getData();
        } else {
          errorNotify(res?.data?.data?.message);
        }
      })
      .catch((err) => {});
  };

  const handleResetFilters = () => {
    const resetFilters = {
      CI_Name: "",
      CI_PassportNo: "",
      CI_PrimaryMobile: "",
      CI_PrimaryEmail: "",
    };

    const isAlreadyReset = Object.entries(resetFilters).every(
      ([key, value]) => filterData[key] === value
    );

    if (!isAlreadyReset) {
      setFilterData(resetFilters);
      getData(resetFilters);
    }

    const encrypted = encodeURIComponent(encryptId(decryptedId));
    const encryptedTitle = encodeURIComponent(encryptId(decryptedTitle));

    navigate(`/Jobs/Applicants/${encrypted}/${encryptedTitle}`, {
      replace: true,
    });
  };

  const getData = (filter = filterData) => {
    const trimmedFilters = {
      CI_Name: filter?.CI_Name,
      CI_PassportNo: filter?.CI_PassportNo,
      CI_PrimaryMobile: filter?.CI_PrimaryMobile,
      CI_PrimaryEmail: filter?.CI_PrimaryEmail,
    };

    axiosAPI
      ?.post(`/clientportal/CandidatebyJob/${decryptedId}`, trimmedFilters)

      .then((res) => {
        setApplicantData(res?.data?.data?.candidates);
        
        setTotalJoined(res?.data?.data?.totalJoined);
        setTotalInterviewAttended(res?.data?.data?.totalInterviewAttended);
        setTotalInterviewSelected(res?.data?.data?.totalInterviewSelected);

        setLoaderOpen(false);
      })
      .catch((err) => {
        errorNotify(`Something went wrong`);
      });
  };

  const getJobData = async () => {
    try {
      const res = await axiosAPI.get(`/Job/listbyIdForView/${decryptedId}`);
      setJobData(res?.data?.data || []);
      
    } catch (err) {
      console.error(err);
    }
  };

  const navigatetoView = (id) => {
    const encrypted = encodeURIComponent(encryptId(id?.CI_Id));

    navigate(`/Candidates/View/${encrypted}`, {
      state: {
        ...paginationState,
        selectedId: JSON.stringify(id),
        fromRoute: "CandJobApplicant",
        decryptedId: decryptedId,
      },
    });
  };

  useEffect(() => {
    getStatus();
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
    if (decryptedId) {
      getJobData();
    }
  }, [page, rowsPerPage, decryptedId]);

  useEffect(() => {
    if (location?.state?.pagination) {
      setPage(location.state.pagination.page || 0);
      setRowsPerPage(location.state.pagination.rowsPerPage || 25);
    }

    if (location?.state?.decryptedId) {
      setdecryptedId(location?.state?.decryptedId);
    } else {
      setdecryptedId(decryptId(decodeURIComponent(id)));
    }

    if (location?.state?.filterData) {
      setFilterData(location.state.filterData);
      getData(location.state.filterData); // fetch with restored filters
    } else {
      getData();
    }
  }, [location?.state, page, rowsPerPage]);

  return (
    <Paper
      sx={{
        maxWidth: `100vw`,
        padding: 2,
        margin: "auto",
        boxShadow: "none",
        overflowX: "auto",
        fontFamily: "Geist, sans-serif",
        minHeight: "100%",
      }}
    >
      <Grid
        container
        justifyContent="space-between"
        alignItems="center"
        mb={2}
        sx={{ flexDirection: { xs: "column", sm: "row" } }}
      >
        <Box display="flex" alignItems="center" flexWrap="wrap">
          <CommonButton
            variant="outlined"
            background="#006CB8"
            onClick={() =>
              navigate(`/Jobs`, {
                state: {
                  pagination: paginationState,
                  filterData: filterData,
                },
              })
            }
            margin="0px 20px 10px 0px"
          >
            <ArrowBackIcon sx={{ color: "white" }} />
          </CommonButton>

          <Typography
            variant="h5"
            sx={{
              fontWeight: 600,
              fontFamily: "Geist, sans-serif",
            }}
          >
            Job Applicants {decryptedTitle ? `of ${decryptedTitle}` : null}
          </Typography>
        </Box>
      </Grid>

      <Grid container spacing={2} mb={2}>
        {/* Left: Job Info (8/12) */}
        <Grid item xs={12} md={9} lg={9}>
          <Card
            variant="outlined"
            sx={{ p: 2, minHeight: { md: "none", lg: "280px" } }}
          >
            <Grid container spacing={2}>
              <Grid item xs={6} sm={4} md={3} lg={4} xl={3}>
                <Typography
                  sx={{
                    fontFamily: "Geist, sans-serif",
                    letterSpacing: `0.5px`,
                    fontSize: "18px",
                    color: "#333",
                    fontWeight: "600",
                  }}
                >
                  Job ID
                </Typography>
                <Typography
                  sx={{
                    fontFamily: "Geist, sans-serif",
                    letterSpacing: `0.5px`,
                    fontSize: "14px",
                    color: "#333",
                    fontWeight: "400",
                  }}
                >
                  {jobData?.JD_JobId}
                </Typography>
              </Grid>
              <Grid item xs={6} sm={4} md={3} lg={4} xl={3}>
                <Typography
                  sx={{
                    fontFamily: "Geist, sans-serif",
                    letterSpacing: `0.5px`,
                    fontSize: "18px",
                    color: "#333",
                    fontWeight: "600",
                  }}
                >
                  Title
                </Typography>
                <Typography
                  sx={{
                    fontFamily: "Geist, sans-serif",
                    letterSpacing: `0.5px`,
                    fontSize: "14px",
                    color: "#333",
                    fontWeight: "400",
                  }}
                >
                  {jobData?.JD_Title}
                </Typography>
              </Grid>
              <Grid item xs={6} sm={4} md={3} lg={4} xl={3}>
                <Typography
                  sx={{
                    fontFamily: "Geist, sans-serif",
                    letterSpacing: `0.5px`,
                    fontSize: "18px",
                    color: "#333",
                    fontWeight: "600",
                  }}
                >
                  Location
                </Typography>
                <Typography
                  sx={{
                    fontFamily: "Geist, sans-serif",
                    letterSpacing: `0.5px`,
                    fontSize: "14px",
                    color: "#333",
                    fontWeight: "400",
                  }}
                >
                  {jobData?.JD_Locations}
                </Typography>
              </Grid>
              <Grid item xs={6} sm={4} md={3} lg={4} xl={3}>
                <Typography
                  sx={{
                    fontFamily: "Geist, sans-serif",
                    letterSpacing: `0.5px`,
                    fontSize: "18px",
                    color: "#333",
                    fontWeight: "600",
                  }}
                >
                  Client
                </Typography>
                <Typography
                  sx={{
                    fontFamily: "Geist, sans-serif",
                    letterSpacing: `0.5px`,
                    fontSize: "14px",
                    color: "#333",
                    fontWeight: "400",
                  }}
                >
                  {jobData?.JD_Client?.Name}
                </Typography>
              </Grid>
              <Grid item xs={6} sm={4} md={3} lg={4} xl={3}>
                <Typography
                  sx={{
                    fontFamily: "Geist, sans-serif",
                    letterSpacing: `0.5px`,
                    fontSize: "18px",
                    color: "#333",
                    fontWeight: "600",
                  }}
                >
                  Country
                </Typography>
                <Typography
                  sx={{
                    fontFamily: "Geist, sans-serif",
                    letterSpacing: `0.5px`,
                    fontSize: "14px",
                    color: "#333",
                    fontWeight: "400",
                  }}
                >
                  {jobData?.JD_Country?.Name}
                </Typography>
              </Grid>
              <Grid item xs={6} sm={4} md={3} lg={4} xl={3}>
                <Typography
                  sx={{
                    fontFamily: "Geist, sans-serif",
                    letterSpacing: `0.5px`,
                    fontSize: "18px",
                    color: "#333",
                    fontWeight: "600",
                  }}
                >
                  Department
                </Typography>
                <Typography
                  sx={{
                    fontFamily: "Geist, sans-serif",
                    letterSpacing: `0.5px`,
                    fontSize: "14px",
                    color: "#333",
                    fontWeight: "400",
                  }}
                >
                  {jobData?.JD_Department ? jobData?.JD_Department : "-"}
                </Typography>
              </Grid>
              <Grid item xs={6} sm={4} md={3} lg={4} xl={3}>
                <Typography
                  sx={{
                    fontFamily: "Geist, sans-serif",
                    letterSpacing: `0.5px`,
                    fontSize: "18px",
                    color: "#333",
                    fontWeight: "600",
                  }}
                >
                  Profession
                </Typography>
                <Typography
                  sx={{
                    fontFamily: "Geist, sans-serif",
                    letterSpacing: `0.5px`,
                    fontSize: "14px",
                    color: "#333",
                    fontWeight: "400",
                  }}
                >
                  {jobData?.JD_Profession?.Name
                    ? jobData?.JD_Profession?.Name
                    : "-"}
                </Typography>
              </Grid>
              <Grid item xs={6} sm={4} md={3} lg={4} xl={3}>
                <Typography
                  sx={{
                    fontFamily: "Geist, sans-serif",
                    letterSpacing: `0.5px`,
                    fontSize: "18px",
                    color: "#333",
                    fontWeight: "600",
                  }}
                >
                  Salary
                </Typography>
                <Typography
                  sx={{
                    fontFamily: "Geist, sans-serif",
                    letterSpacing: "0.5px",
                    fontSize: "14px",
                    color: "#333",
                    fontWeight: "400",
                  }}
                >
                  {jobData?.JD_SalaryRange &&
                  jobData?.JD_Currency?.Code &&
                  jobData?.JD_SalaryPay
                    ? ` ${jobData?.JD_SalaryRange} ${jobData?.JD_Currency?.Code} / ${jobData?.JD_SalaryPay}`
                    : "-"}
                </Typography>
              </Grid>
              <Grid item xs={6} sm={4} md={3} lg={4} xl={3}>
                <Typography
                  sx={{
                    fontFamily: "Geist, sans-serif",
                    letterSpacing: `0.5px`,
                    fontSize: "18px",
                    color: "#333",
                    fontWeight: "600",
                  }}
                >
                  Age Limit
                </Typography>
                <Typography
                  sx={{
                    fontFamily: "Geist, sans-serif",
                    letterSpacing: `0.5px`,
                    fontSize: "14px",
                    color: "#333",
                    fontWeight: "400",
                  }}
                >
                  {jobData?.JD_MinAge && jobData?.JD_MaxAge
                    ? `${jobData?.JD_MinAge} - ${jobData?.JD_MaxAge}`
                    : "-"}
                </Typography>
              </Grid>
              <Grid item xs={6} sm={4} md={3} lg={4} xl={3}>
                <Typography
                  sx={{
                    fontFamily: "Geist, sans-serif",
                    letterSpacing: `0.5px`,
                    fontSize: "18px",
                    color: "#333",
                    fontWeight: "600",
                  }}
                >
                  Open Date
                </Typography>
                <Typography
                  sx={{
                    fontFamily: "Geist, sans-serif",
                    letterSpacing: `0.5px`,
                    fontSize: "14px",
                    color: "#333",
                    fontWeight: "400",
                  }}
                >
                  {jobData?.JD_OpenDate}
                </Typography>
              </Grid>
              <Grid item xs={6} sm={4} md={3} lg={4} xl={3}>
                <Typography
                  sx={{
                    fontFamily: "Geist, sans-serif",
                    letterSpacing: `0.5px`,
                    fontSize: "18px",
                    color: "#333",
                    fontWeight: "600",
                  }}
                >
                  Close Date
                </Typography>
                <Typography
                  sx={{
                    fontFamily: "Geist, sans-serif",
                    letterSpacing: `0.5px`,
                    fontSize: "14px",
                    color: "#333",
                    fontWeight: "400",
                  }}
                >
                  {jobData?.JD_CloseDate}
                </Typography>
              </Grid>
              <Grid item xs={6} sm={4} md={3} lg={4} xl={3}>
                <Typography
                  sx={{
                    fontFamily: "Geist, sans-serif",
                    letterSpacing: `0.5px`,
                    fontSize: "18px",
                    color: "#333",
                    fontWeight: "600",
                  }}
                >
                  No. of Openings
                </Typography>
                <Typography
                  sx={{
                    fontFamily: "Geist, sans-serif",
                    letterSpacing: `0.5px`,
                    fontSize: "14px",
                    color: "#333",
                    fontWeight: "400",
                  }}
                >
                  {jobData?.JD_NoofOpening ? jobData?.JD_NoofOpening : "-"}
                </Typography>
              </Grid>

              <Grid item xs={12} sm={6}>
                <Typography
                  sx={{
                    fontFamily: "Geist, sans-serif",
                    letterSpacing: `0.5px`,
                    fontSize: "18px",
                    color: "#333",
                    fontWeight: "600",
                  }}
                >
                  Qualification
                </Typography>
                <Typography
                  sx={{
                    fontFamily: "Geist, sans-serif",
                    letterSpacing: `0.5px`,
                    fontSize: "14px",
                    color: "#333",
                    fontWeight: "400",
                  }}
                >
                  {Array.isArray(jobData.JD_Qualification)
                    ? jobData.JD_Qualification.map((a) => a?.Name).join(", ")
                    : jobData.JD_Qualification || "-"}
                </Typography>
              </Grid>
            </Grid>
          </Card>
        </Grid>

        {/* Right: Status Boxes (4/12) */}
        <Grid item xs={12} md={3} lg={3}>
          <Card
            variant="outlined"
            sx={{
              p: 2,
              height: "100%",
              display: "flex",
              flexDirection: "column",
            }}
          >
            <Grid container spacing={2} sx={{ flexGrow: 1 }}>
              {/* Card Wrapper for Each Status */}
              {[
                {
                  label: "Total Joined",
                  value: totalJoined,
                  bg: "#e3f2fd",
                },
                {
                  label: "Interview Attended",
                  value: totalInterviewAttended,
                  bg: "#fff3e0",
                },
                {
                  label: "Interview Selected",
                  value: totalInterviewSelected,
                  bg: "#e8f5e9",
                },
              ].map((item, index) => (
                <Grid item xs={12} key={index}>
                  <Card
                    sx={{
                      backgroundColor: item.bg,
                      p: 2,
                      height: "100%",
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center",
                    }}
                  >
                    <Box
                      display="flex"
                      justifyContent="space-between"
                      alignItems="center"
                    >
                      <Typography
                        sx={{
                          fontFamily: "Geist, sans-serif",
                          letterSpacing: "0.5px",
                          fontSize: "18px",
                          color: "#333",
                          fontWeight: "600",
                        }}
                      >
                        {item.label}
                      </Typography>
                      <Typography variant="h5">{item.value ?? 0}</Typography>
                    </Box>
                  </Card>
                </Grid>
              ))}
            </Grid>
          </Card>
        </Grid>
      </Grid>

      {/* Filters */}
      <Box sx={{ width: "100%", mb: 2 }}>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={4} md={4} lg={3} xl={3}>
            <Typography
              variant="subtitle1"
              sx={{ fontWeight: 500, fontFamily: "Geist, sans-serif" }}
            >
              Name
            </Typography>
            <TextField
              placeholder="Name"
              variant="outlined"
              size="small"
              value={filterData.CI_Name}
              onChange={(e) =>
                setFilterData((prev) => ({ ...prev, CI_Name: e.target.value }))
              }
              sx={{ width: { xs: "100%" } }}
            />
          </Grid>

          <Grid item xs={12} sm={4} md={4} lg={3} xl={3}>
            <Typography
              variant="subtitle1"
              sx={{ fontWeight: 500, fontFamily: "Geist, sans-serif" }}
            >
              Passport Number
            </Typography>
            <TextField
              placeholder="Passport Number"
              variant="outlined"
              size="small"
              value={filterData.CI_PassportNo}
              onChange={(e) =>
                setFilterData((prev) => ({
                  ...prev,
                  CI_PassportNo: e.target.value,
                }))
              }
              sx={{ width: { xs: "100%" } }}
            />
          </Grid>

          <Grid item xs={12} sm={4} md={4} lg={3} xl={3}>
            <Typography
              variant="subtitle1"
              sx={{ fontWeight: 500, fontFamily: "Geist, sans-serif" }}
            >
              Mobile Number
            </Typography>
            <TextField
              placeholder="Mobile Number"
              variant="outlined"
              size="small"
              value={filterData.CI_PrimaryMobile}
              onChange={(e) =>
                setFilterData((prev) => ({
                  ...prev,
                  CI_PrimaryMobile: e.target.value,
                }))
              }
              sx={{ width: { xs: "100%" } }}
            />
          </Grid>

          <Grid item xs={12} sm={4} md={4} lg={3} xl={3}>
            <Typography
              variant="subtitle1"
              sx={{ fontWeight: 500, fontFamily: "Geist, sans-serif" }}
            >
              Email
            </Typography>
            <TextField
              placeholder="Email"
              variant="outlined"
              size="small"
              value={filterData.CI_PrimaryEmail}
              onChange={(e) =>
                setFilterData((prev) => ({
                  ...prev,
                  CI_PrimaryEmail: e.target.value,
                }))
              }
              sx={{ width: { xs: "100%" } }}
            />
          </Grid>
        </Grid>
      </Box>

      {/* Buttons */}
      <Box
        sx={{
          width: "100%", // Full width
          display: "flex",
          justifyContent: "flex-end", // Align buttons to the right
          alignItems: "flex-end",
          gap: 1,
          my: 2,
        }}
      >
        <Button
          variant="outlined"
          startIcon={<Search />}
          onClick={handleApplyFilters}
          sx={{
            textTransform: "capitalize",
            color: "white",
            background: "#006CB8",
          }}
        >
          Search
        </Button>
        <Button
          variant="outlined"
          startIcon={<RestartAlt />}
          onClick={handleResetFilters}
          sx={{ textTransform: "capitalize" }}
        >
          Reset
        </Button>
      </Box>

      {/* Outer scroll container */}
      <Box sx={{ width: "100%", overflowX: "auto" }}>
        {/* Table container with minWidth */}
        <Grid container direction="column" sx={{ minWidth: "1600px", minHeight:"300px"}}>
          {/* Header Row */}
          <Grid
            container
            sx={{
              backgroundColor: "#006CB8",
              color: "white",
              p: 1.5,
              borderRadius: "10px 10px 0px 0px",
            }}
          >
            <Grid item xs={1.9}>
              <Typography variant="subtitle2" fontWeight="600">Name</Typography>
            </Grid>
            <Grid item xs={1.2}>
              <Typography variant="subtitle2" fontWeight="600">Profession</Typography>
            </Grid>
            <Grid item xs={1.2}>
              <Typography variant="subtitle2" fontWeight="600">Passport Number</Typography>
            </Grid>
            <Grid item xs={1.5}>
              <Typography variant="subtitle2" fontWeight="600">Phone</Typography>
            </Grid>
            <Grid item xs={1.5}>
              <Typography variant="subtitle2" fontWeight="600">Email</Typography>
            </Grid>
            <Grid item xs={1}>
              <Typography variant="subtitle2" fontWeight="600">CV Sent</Typography>
            </Grid>
            <Grid item xs={1}>
              <Typography variant="subtitle2" fontWeight="600">Job Offer Status</Typography>
            </Grid>
            <Grid item xs={2.7}>
              <Typography variant="subtitle2" fontWeight="600">Interview Status</Typography>
            </Grid>
          </Grid>

          {/* Data Rows */}
          {applicantData && applicantData.length > 0 ? (
            applicantData.map((parent, index) => (
              <Grid
                container
                key={index}
                alignItems="center"
                sx={{
                  border: "1px solid lightgrey",
                  p: 2,
                 
                }}
              >
                {/* Name */}
                <Grid item xs={1.9}>
                  <Box display="flex" alignItems="center">
                    <Avatar
                      src={
                        parent?.CI_Photo
                          ? `${process.env.REACT_APP_BASE_URL}/${parent.CI_Photo}`
                          : undefined
                      }
                      sx={{ width: 46, height: 46, mr: 1 }}
                    >
                      {parent?.CI_Name?.[0] || ""}
                    </Avatar>
                    <Typography variant="body2">{parent?.CI_Name || "-"}</Typography>
                  </Box>
                </Grid>

                {/* Profession */}
                <Grid item xs={1.2}>
                  <Typography variant="body2">{parent.profession_Name || "-"}</Typography>
                </Grid>

                {/* Passport Number */}
                <Grid item xs={1.2}>
                  <Typography variant="body2">{parent.CI_PassportNo || "-"}</Typography>
                </Grid>

                {/* Phone */}
                <Grid item xs={1.5}>
                  <Typography variant="body2">{parent.CI_PrimaryMobile || "-"}</Typography>
                </Grid>

                {/* Email */}
                <Grid item xs={1.5}>
                  <Typography variant="body2">{parent.CI_PrimaryEmail || "-"}</Typography>
                </Grid>

                {/* CV Sent */}
                <Grid item xs={1}>
                  <Typography variant="body2">{parent.JA_Cvsent ? "Yes" : "No"}</Typography>
                </Grid>

                {/* Job Offer Status */}
                <Grid item xs={1}>
                  <Typography variant="body2">{parent.JA_Shortlisted ? "Yes" : "No"}</Typography>
                </Grid>

                {/* Interview Status */}
                <Grid item xs={2.7} onClick={() => {
                  setCandidateID(parent?.CI_Id);
                  setJobApplicationId(parent?.JA_Id)
                 

                }}>
            
                  <FormControl fullWidth size="small" sx={{ backgroundColor: "white" }}>
                    <SelectInput
                      value={parent?.JASL_Id}
                      name="jobapplication"
                      onChange={(e) => handleStatusChange(e)}
                      options={statusList?.map((item) => ({
                        value: item?.JASL_Id,
                        label: item?.JASL_Name,
                      }))}
                      placeholder="Select Status"
                    />
                  </FormControl>
                </Grid>
              </Grid>
            ))
          ) : (
            <Box
              height={150}
              display="flex"
              justifyContent="center"
              alignItems="center"
              sx={{
                color: "grey",
                fontSize: "28px",
                width: "100%",
              }}
            >
              <Typography
                sx={{
                  fontFamily: "Geist, sans-serif",
                  letterSpacing: `0.5px`,
                  fontSize: "24px",
                  color: "grey",
                  fontWeight: "600",
                }}
              >
                No data to show
              </Typography>
            </Box>
          )}
        </Grid>
      </Box>


      {/* Pagination */}
      <TablePagination
        component="div"
        count={applicantData?.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
        rowsPerPageOptions={[25, 50, 75, 100]}
        sx={{
          // General font size for the pagination root
          fontSize: { xs: "12px", sm: "14px" },
          // Specific font size for the "Rows per page" label
          "& .MuiTablePagination-selectLabel": {
            fontSize: { xs: "12px", sm: "14px" },
            fontFamily: "Geist, sans-serif", // Optional
          },
        }}
      />

      {/* <Backdrop
        open={loaderOpen}
        sx={{
          zIndex: (theme) => theme.zIndex.drawer + 1,
          color: "#fff",
          backdropFilter: "blur(5px)",
          backgroundColor: "rgba(0, 0, 0, 0.2)",
          flexDirection: "column",
        }}
      >
        <CircularProgress color="inherit" />
      </Backdrop> */}
    </Paper>
  );
};

export default ClientJobApplicantList;
